import React, { useRef, useCallback, useMemo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { includes } from 'lodash';

import { number } from '~/helpers';
import { Edit, Visibility, AttachFile } from '@material-ui/icons';
import api from '~/services/api';
import qs from 'querystring';
import { UnidataTable, Modal } from '~/components';
import {
  recordFiltering,
  deletePleitoPosto
} from '~/store/modules/pleitoposto/actions';

import { resetParams } from '~/store/modules/hooks/actions';
import { Typography } from '@material-ui/core';

import { format, setHours, setMinutes, setSeconds, subDays, parseISO } from 'date-fns';

import FormUpdate from './FormUpdate';
import Form from './Form';
import DetalheObservacao from './DetalheObservacao'
import UploadPleitoPosto from './UploadPleitoPosto'


import { ADM } from '~/constants/perfil';

import { GFE, GFO, GFU, GPP, GPPE, GPPEM } from '~/constants/perfil';

import { SelectComplete } from '~/componentslocal';
import { isEmpty } from 'lodash';

function OperacaoPleitoPosto() {
  const dispatch = useDispatch();

  const data = useSelector((state) => state.pleitoposto);

  const { profile } = useSelector(state => state.user);

  const [loading, setLoading] = useState(true)

  const [isADM, setIsADM] = useState(false)

  const [isVisualizar, setIsVisualizar] = useState(false)


  const [situacoes, setSituacoes] = useState([])

  const [selectedRow, setSelectedRow] = useState({})

  const modalRef = useRef(null)
  const modalRefObs = useRef(null)
  const modalRefUpload = useRef(null)

  const refFormUpdate = useRef(null)

  const { glousuariotipo } = useSelector(
    (state) => state.user.profile
  );


  useEffect(() => {

    if (profile.perfcodigo == String(ADM)) {
      setIsADM(true)
    } else if (includes([GFE, GFO, GFU, GPP, GPPE, GPPEM], glousuariotipo)) {
      setIsVisualizar(true)
    }
  }, [profile, GFE, GFO, GFU, GPP])

  const handleGetSituacoes = useCallback(async () => {
    const response = await api.get('pleito/pleitosituacao', {
      params: {
        wherefield: ['plsi_tipo'],
        valuewherefield: ['P'],
        typewherefield: ['EQUALS'],
        pagesize: 99999999,
      },
      paramsSerializer: (param) => qs.stringify(param),
    })
    setSituacoes(response.data.items)
  }, [])

  useEffect(() => {
    handleGetSituacoes();
  }, [])

  /*
      const optionsSituacoes = useMemo(() => {
  
          let arraySituacoes = []
          if (!isEmpty(situacoes)) {
              arraySituacoes = situacoes.map((item) => {
                  return {
                      label: item.plsi_codigo,
                      value: item.plsi_descritivo
                  }
              })
          }
  
          return arraySituacoes
      }, [situacoes])
      */

  const optionsSituacoes = useMemo(() => {

    let arraySituacoes = []
    if (!isEmpty(situacoes)) {
      arraySituacoes = situacoes.map((item) => {
        return {
          label: item.plsi_descritivo,
          value: item.plsi_descritivo
        }
      })
    }

    return arraySituacoes
  }, [situacoes])


  useEffect(() => {
    if (!isEmpty(optionsSituacoes)) {
      setLoading(false)
    }
  }, [optionsSituacoes])

  /*
      const optionsStatus = useMemo(
          () =>
              [
                  { label: 'A', value: 'Aberto' },
                  { label: 'C', value: 'Cancelado' },
                  { label: 'F', value: 'Autorizado Nota Fiscal' },
                  { label: 'P', value: 'Pago' },
              ], [])
              */
  const optionsStatus = useMemo(
    () =>
      [
        { label: 'Aberto', value: 'Aberto' },
        { label: 'Cancelado', value: 'Cancelado' },
        { label: 'Autorizado Nota Fiscal', value: 'Autorizado Nota Fiscal' },
        { label: 'Pago', value: 'Pago' },
      ], [])

  const header = useMemo(
    () => {
      let tempArrayHeader = [
        { id: 'plei_codigo', label: 'Código', filter: { type: 'text' } },
        {
          id: 'plei_datahora_pleito', label: 'Data do pleito',
          formatted: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
        },
        { id: 'poco_desc_abrev', label: 'Posto', filter: { type: 'text' } },
        {
          //id: 'plsi_codigo',
          id: 'plsi_descritivo',
          label: 'Situação',
          //formatted: (value) => value ? optionsSituacoes.find((option) => option.label === value).value : value,
          filter: {
            type: 'select',
            options: optionsSituacoes
          }
        },
        { id: 'orga_nome', label: 'Órgão', filter: { type: 'text' } },
        { id: 'plei_numero_laudo', label: 'Número do Laudo', filter: { type: 'text' } },
        {
          id: 'plei_valor_pleito',
          label: 'Valor do Pleito',
          formatted: (value) => number(value, 2),
          filter: { type: 'text' }
        },
        {
          id: 'plei_datahora_envio', label: 'Data Envio Pleito',
          formatted: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
        },
        {
          //id: 'plei_status',
          id: 'plei_status_str',
          label: 'Status',
          //formatted: (value) => optionsStatus.find((option) => option.label === value).value,
          filter: {
            type: 'select',
            options: optionsStatus,
          }
        },

      ]

      isADM && tempArrayHeader.push({
        id: 'plei_datahora_autorizado_nf', label: 'Data Autorização NF',
        formatted: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
      })

      isADM && tempArrayHeader.push({ id: 'plei_numero_pedido', label: 'Número do Pedido', filter: { type: 'text' } },)


      tempArrayHeader = [
        ...tempArrayHeader,
        { id: 'plei_nota_fiscal_servico', label: 'Número NF Serviço', filter: { type: 'text' } },
        { id: 'plei_nota_fiscal_produto', label: 'Número NF Produto', filter: { type: 'text' } },
        {
          id: 'plei_datahora_pagamento_nota_fiscal', label: 'Data Pagamento NF',
          formatted: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
        },
        {
          id: 'plei_datahora_cancelado', label: 'Data Cancelamento',
          formatted: (value) => value ? format(parseISO(value), 'dd/MM/yyyy') : ''
        },]

      isADM && tempArrayHeader.push({
        id: 'plei_observacao',
        label: 'Observação',
        formatted: (value) => value && value.length > 10 ? value.substring(0, 5) + '...' : value,
      })

      return tempArrayHeader
    },
    [optionsStatus, optionsSituacoes, isADM]
  );


  const actionButtons = useMemo(
    () => {
      let arrayButtons = []

      isADM && arrayButtons.push({
        title: 'Alterar',
        action: (value) => modalRef.current.handleOpenModal({ data: value, reference: refFormUpdate }),
        icon: <Edit />,
      })

      isADM && arrayButtons.push({
        title: 'Visualizar Observação',
        action: (value) => modalRefObs.current.handleOpenModal({ data: value }),
        icon: <Visibility />,
      })

      isADM && arrayButtons.push({
        title: 'Upload Anexos',
        action: (value) => modalRefUpload.current.handleOpenModal({ data: value }),
        icon: <AttachFile />,
      })

      isVisualizar && arrayButtons.push({
        title: 'Anexos',
        action: (value) => modalRefUpload.current.handleOpenModal({ data: value }),
        icon: <AttachFile />,
      })



      return arrayButtons;
    }
    , [isADM, modalRefObs, modalRefUpload, refFormUpdate, isVisualizar])


  const actionsModalObs = useMemo(() => [{
    label: 'Fechar',
    color: 'secondary',
    callback: () => modalRefObs.current.handleCloseModal(),
  }], [modalRefObs])


  const actionsModalUpload = useMemo(() => [{
    label: 'Fechar',
    color: 'secondary',
    callback: () => modalRefUpload.current.handleCloseModal(),
  }], [modalRefUpload])


  return (
    <>
      {!loading && <UnidataTable
        excel
        pdf
        reportOrder="plei_codigo ASC"
        fixed
        header={header}
        redux={data}
        update={false}
        create={isADM}
        delete={isADM}
        keys="plei_codigo"
        detach="plei_codigo"
        read={recordFiltering}
        remove={deletePleitoPosto}
        form={Form}
        onRow={setSelectedRow}
        actions={actionButtons}
        view="VW_TB_PLEITO"
        reportTitle="Pleito Posto"
      />
      }

      <Modal
        form
        ref={modalRef}
        component={FormUpdate}
        title="Editar Pleito Posto"
        maxWidth="sm"
      />

      <Modal
        ref={modalRefObs}
        component={DetalheObservacao}
        title="Observação Pleito Posto"
        maxWidth="sm"
        actions={actionsModalObs}
      />

      <Modal
        form
        ref={modalRefUpload}
        component={UploadPleitoPosto}
        title="Upload Anexos"
        maxWidth="sm"
      />

    </>
  );
}

export default OperacaoPleitoPosto;
